/**
 * Build-time feature flags for screens that are not finished.
 *
 * Off unless the build sets REACT_APP_FEATURE_<NAME>=true. A screen behind a
 * flag shows <FeatureUnavailable/> instead of a form that cannot work.
 *
 *  - reports: generated reports read lifetime counters capped at 500 rows,
 *    label their period wrongly and are not real PDFs; scheduled reports
 *    are never run or emailed (there is no scheduler). Review 2026-10-13, M4.
 *  - conversionGoals: goals have no tracking source wired up, so every goal
 *    would read 0. Review 2026-10-13, M5.
 */
const on = (value) => String(value || '').toLowerCase() === 'true';

export const FEATURES = {
  reports: on(process.env.REACT_APP_FEATURE_REPORTS),
  conversionGoals: on(process.env.REACT_APP_FEATURE_CONVERSION_GOALS),
};

export default FEATURES;
